<template>
    <div class="wrapper">
        <div class="columns">
            <div class="column is-full">
                <div style="padding-top: 20px; width: 100%;">
                    <table class="table is-responsive is-fullwidth">
                        <thead>
                        <tr>
                            <th>Date</th>
                            <th>Manager</th>
                            <th>Comment</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="log in logs">
                            <td>{{ log.created_at }}</td>
                            <td>{{ log.manager.name }}</td>
                            <td>{{ log.comment }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column is-full">
                <div class="field">
                    <label class="label">Message</label>
                    <div class="control">
                        <textarea class="textarea" placeholder="Type your message here" v-model="log.comment"></textarea>
                    </div>
                </div>
                <div class="field is-grouped">
                    <div class="control">
                        <button class="button is-link" :class="{ 'is-loading' : isLoading }" @click="createUserLog">Submit</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import apiUserLogs from './../../../../api/apiUserLogs'
    export default {
        props: ['user'],
        data() {
            return {
                logs: [],
                log: {
                    user_id: this.user.id,
                    comment: null
                },
                isLoading: false
            }
        },
        methods: {
            createUserLog(){
                this.isLoading = true
                apiUserLogs
                    .createUserLogRequest(this.log)
                    .then((response) => {
                        this.isLoading = false
                        this.logs = response.data
                    })
                    .catch((error) => {
                        this.isLoading = false
                    })

            }
        },
        created() {
            apiUserLogs
                .userLogsListRequest(this.user.id)
                .then((response) => {
                    this.logs = response.data
                })
                .catch((error) => {
                    this.isLoading = false
                })
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Users/User/Tabs/UserLogs.vue